(function () {
  var
  $mainContent = $('.multistep-main-content'),
  $nextBtn = $('.js-multistep-next-btn'),
  $formWrap,

  dimBackground = function () {
    $mainContent.addClass('multistep-main-content--dim-background');
  },

  moveToNextPanel = function($formWrap) {
    var $form = $formWrap.find('form');
    var currentStep = $formWrap.data('step');

    if( $form.valid() ) {
      dimBackground();
      currentStep += 1;
      $formWrap.data('step', currentStep).attr('data-step', currentStep);
      // Focus cursor on next step's first input
      $formWrap.find('.multistep-panel--' + currentStep + ' input')[0].focus();

      // Emit an event for consuming apps so they can do their unique things
      // format: 'mslf.panel1.complete'
      var event = document.createEvent('Event');
      event.initEvent('mslf.panel' + (currentStep - 1) + '.complete', true, true);
      $formWrap[0].dispatchEvent(event);
    }
  };

  $nextBtn.on('click', function() {
    // Find the wrapping element for the form that contains the button being clicked
    $formWrap = $(this).closest('.contact-form--multistep');
    moveToNextPanel($formWrap);
  });
}());
